import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useHistory } from 'react-router-dom'
import swal from 'sweetalert';
import { toast } from "react-toastify";
import { CSVLink } from "react-csv";
import filter from '../../assets/filter.svg'
import download from '../../assets/download.svg'
import { Navbar } from '../../Components/Navbar'
import arrow from '../../assets/arrowLeftGreen.svg'
import { fetchDeletedAdj, fetchSAAdjustment } from '../../redux/actions/actionStandaloneAdj';
import { restoreAdjustment } from '../../services/api/apiHandler';
import Loading from '../../Components/Common/Loader/Loading';
import { socket } from '../../services/socket/socket';
import moment from 'moment';
import AdjustmentFilter from './components/AdjustmentFilter';
import { applyAdjFilter } from './adjustmentHelperFunction';


import { motion } from "framer-motion";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import { Button } from "../../myfin_v2/elements/Button";
import buttoncss from "../../myfin_v2/css/button.module.css";
// import BookClosureTable from "../../myfin_v2/elements/BookClosureTable";
import { ReactComponent as FilterIcon } from "../../myfin_v2/assets/icons/filter.svg";
import { ReactComponent as ExportIcon } from "../../myfin_v2/assets/icons/download.svg";
import { ReactComponent as RestoreIcon } from "../../myfin_v2/assets/icons/restore.svg";
import RestorePopup from "../../myfin_v2/elements/RestorePopup";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";
import Checkmark from "../../myfin_v2/assets/icons/Check(circle).png";
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import wsCreationcss from "../../myfin_v2/css/workspaceCreation.module.css";

const adjustmentsTable = {
  minWidth: '1045px',
  height: '100vh'
}

const AdjustmentsDeleted = (props) => {
  const user = JSON.parse(localStorage.getItem('user'));
  const dispatch = useDispatch();
  const history = useHistory()
  const project_id = localStorage.getItem('project_id');
  const tb_id = localStorage.getItem("tb_id");

  const {
    dltAdjLoading,
    dle_adj_error_message,
    dltAdjIsSuccess,
    dleAdjData,
    copyDleAdjData
  } = useSelector((initialState) => initialState.ADJStandaloneReducer);
  const filterData = useSelector((initialState) => initialState.reducer.filter);

  const [exportAdjustments, setExportAdjustments] = useState([]);
  const [filterShow, setFilterShow] = useState(false);
  const [state, setstate] = useState([]);
  const [restoreConfirmData, setRestoreConfirmData] = useState(null);
  const [showSuccessPopup, setShowSuccessPopup] = useState(false);

  useEffect(() => {
    dispatch(fetchDeletedAdj(project_id, tb_id));
  }, [dltAdjIsSuccess]);

  useEffect(() => {
    dispatch(fetchDeletedAdj(project_id, tb_id));
  }, []);

  useEffect(() => {
    if (dleAdjData && dleAdjData.length > 0) {
      let serialCounter = 1;
      dleAdjData.forEach((adj, i) => {
        const sortedKeys = Object.keys(adj);
        const first = adj[sortedKeys[0]];

        first.forEach((row) => {
          setExportAdjustments((prev) => [
            ...prev,
            {
              SlNo: serialCounter++,
              ModifiedDate: moment(adj.date).format("DD/MM/YYYY"),
              LedgerCode: row?.ledger_code,
              LedgerName: row.ledger_name,
              cy: row.cy,
              adjustment: row.adjusted_amount,
              remarks: adj.remarks || adj.remark,
            },
          ]);
        });
      });
    }
  }, [dleAdjData]);


  const handleRestore = (item, index) => {
    if (user.responsibilities === "approver" || user.responsibilities === "view") {
      swal("Warning", 'You dont have any access to restore records', 'warning')
      return false;
    }
    setRestoreConfirmData({ item, index });
  }

  const csvLink = {
    data: [...exportAdjustments],
    filename: "DeletedAdjustmentLogs.csv",
  };

  const handleApplyFilter = () => {
    dispatch(applyAdjFilter(copyDleAdjData, filterData, "ADJ_DELETED_FILTER"));
  }

  const workspaceName = sessionStorage.getItem("adj_workspace_name") || localStorage.getItem("workspaceName") || "Workspace";
  const standaloneName = sessionStorage.getItem("adj_standalone_name") || localStorage.getItem("projectName") || "Standalone";

  const nf = new Intl.NumberFormat();
  const breadcrumbItems = [
    {
      label: workspaceName,
      link: `/adjustments`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: standaloneName,
      link: `/adjustments`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    {
      label: "Adjustments",
      link: `/adjustments`,
      className: `${commoncss.nav_cnt_color} clickable`,
    },
    { label: "Deleted Adjustments", link: "", className: "headerLable" },
  ];
  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ overflowY: "auto" }} >

            <div className="fscp-header" style={{ padding: "15px 0px" }}>
              <Breadcrumb
                style="margin-right:auto"
                addCls={"bgClr1"}
                items={breadcrumbItems}
                headerActions={<></>}
              />
              {/* <SearchIcon width={18} height={18} className="mr-2" /> */}
              <FilterIcon
                width={20}
                height={20}
                className={`mr-2 ${commoncss.clickable}`}
                onClick={() => setFilterShow(!filterShow)}
              />
              <CSVLink {...csvLink}>
                <Button
                  icon={<ExportIcon width={18} height={18} />}
                  btnColor={buttoncss.secondary}
                  class_={buttoncss.greyBg}
                  label={"Export"}
                />
              </CSVLink>
            </div>

            <div
              className={`${bookclosuretablecss.bookClosureTableContainer} ${commoncss.hideScroll}`}
              style={{ overflow: "auto", height: "85vh", backgroundColor: "#fff", border: "1px solid #dddddd", borderRadius: "10px", marginLeft: "24px", marginRight: "20px", width: "calc(100% - 44px)", marginTop: "15px", marginBottom: "15px" }}
            >
              {
                dltAdjLoading ? <Loading /> :
                  <table
                    className={`adj-del-table ${bookclosuretablecss.bookClosureTable} ${bookclosuretablecss.bookclosureEntries} ${commoncss.hideScroll}`}
                  >
                    <style>{`
                      .adj-del-table th:last-child,
                      .adj-del-table td:last-child {
                        padding-right: 15px !important;
                      }
                    `}</style>
                    <thead style={{ borderBottom: "1px solid #dddddd" }}>
                      <tr>
                        <th className='text-left pl-3' style={{
                          minWidth: "60px",
                        }} >S no</th>
                        <th className='text-left pl-3'
                          style={{
                            minWidth: "150px",
                          }} >Modified Date</th>
                        <th className='text-left pl-3' style={{ minWidth: "150px" }} >Ledger Code</th>
                        <th className='text-left pl-3' style={{ minWidth: "250px" }} >Ledger Name</th>
                        <th className='text-center' style={{ minWidth: "150px" }} >Branch</th>
                        <th className='text-right pr-3' style={{ minWidth: "150px" }} >31 Mar 2021</th>
                        <th style={{ minWidth: "150px" }} className='text-right pr-3' >Adjustments</th>
                        <th className='text-center' style={{ minWidth: "250px" }} >Remarks</th>
                        <th style={{ minWidth: "30px" }} className='text-center pl-3'></th>
                      </tr>
                    </thead>
                    <tbody>
                      {dleAdjData?.length > 0 && dleAdjData.map((adj, i) => {
                        const sortedKeys = Object.keys(adj);
                        const first = adj[sortedKeys[0]];
                        return first.map((val, ix) => {
                          return (
                            <tr className='bg-white' key={ix}>
                              {
                                ix === 0 ?
                                  <td className='text-left pl-3' rowSpan={ix === 0 && first.length}>{i + 1}</td> : <></>
                              }
                              {
                                ix === 0 ?
                                  <td className='text-left pl-3' rowSpan={ix === 0 && first.length}>
                                    {moment(adj.date).format("DD/MM/YYYY")}
                                  </td> : <></>
                              }
                              <td className='text-center'>{val?.ledger_code}</td>
                              <td className='text-left pl-3'>{val?.ledger_name}</td>
                              <td className='text-center'>{val?.branch}</td>
                              <td className='text-right pr-3'>{nf.format(val.cy)}</td>
                              <td className='text-right pr-3'>{nf.format(val.adjusted_amount)}</td>
                              {
                                ix === 0 ?
                                  <td className='text-center' rowSpan={ix === 0 && first.length}>{adj?.remarks}</td> : <></>
                              }
                              {
                                ix === 0 ?
                                  <td className='text-center' rowSpan={ix === 0 && first.length}>
                                    <RestoreIcon className={commoncss.clickable}
                                      onClick={() => { handleRestore(adj, i) }} />
                                  </td> : <></>
                              }
                            </tr>
                          )
                        })
                      })}
                    </tbody>
                  </table>
              }
              {
                dleAdjData?.length <= 0 &&
                <p className="w-100 text-center text-secondary" > Deleted Adjustment Data Is Empty. </p>
              }
            </div>

          </motion.div>

          <AdjustmentFilter
            actionFrom={"deleted_adj"}
            show={filterShow}
            handleApplyFilter={handleApplyFilter}
            setFilterShow={setFilterShow}
            setObject={() => { }}
            state={state}
            setstate={setstate}
          />
        </div>
      </div >
      <RestorePopup
        isOpen={restoreConfirmData !== null}
        title={<>Do you want to <span style={{ fontWeight: 700 }}>restore</span> this item?</>}
        message="This will restore the item from the bin"
        onConfirm={() => {
          if (!restoreConfirmData) return;
          const { item, index } = restoreConfirmData;
          setRestoreConfirmData(null);
          
          restoreAdjustment(project_id, tb_id, { item, index }).then(response => {
            setShowSuccessPopup(true);
            setTimeout(() => setShowSuccessPopup(false), 2000);
            dispatch(fetchDeletedAdj(project_id, tb_id));
            dispatch(fetchSAAdjustment(project_id, tb_id));
            socket.emit("request-conventional-mode", { project_id, tb_id });
            socket.emit("request-mapped-grouping", { project_id, tb_id });
            socket.emit("request-balance-sheet", { project_id, tb_id });
            socket.emit("request-pnl-statement", { project_id, tb_id });
          }).catch(error => {
            swal("Error", error.response?.data?.error || "Internal Server Error", "error");
          });
        }}
        onCancel={() => setRestoreConfirmData(null)}
      />
      {showSuccessPopup && (
        <div className={commoncss.overlay} style={{ position: "fixed", top: 0, left: 0, right: 0, bottom: 0, zIndex: 99999 }}>
          <div className={commoncss.popup} style={{ width: "380px", height: "245px"}}>
            <div className={commoncss.iconWrapper} >
              <img src={Checkmark} alt="Success" width={90} height={90} />
            </div>
            <p className={commoncss.restoreText}>Item Restored Successfully</p>
          </div>
        </div>
      )}
    </>
  )
}

export default AdjustmentsDeleted;